import request from '@/utils/request'
import { AxiosPromise } from 'axios'
import {
  WechatJSSignature,
  DictItem,
  House,
  Parking,
  Plate,
  AccountRequestParam,
  AccountResponse, DepartmentItem
} from '@/interfaces/basic'

export function getDictById (id: string): AxiosPromise<Array<DictItem>> {
  return request({
    url: `/dicts/${id}`,
    method: 'get'
  })
}

export function getAllDict (areaId: number): AxiosPromise<Array<DictItem>> {
  return request({
    url: `/dicts/${areaId}/dictionaries`,
    method: 'get'
  })
}

export function getHouseById (areaId: number, houseId: number): AxiosPromise<House> {
  return request({
    url: `/areas/${areaId}/houses/${houseId}`,
    method: 'get'
  })
}

export function getParkingById (areaId: number, parkingId: number): AxiosPromise<Parking> {
  return request({
    url: `/areas/${areaId}/parking/${parkingId}`,
    method: 'get'
  })
}

export function getPlateById (areaId: number, plateId: number): AxiosPromise<Plate> {
  return request({
    url: `/areas/${areaId}/plates/${plateId}`,
    method: 'get'
  })
}

export function getWechatJSSignature (url: string): AxiosPromise<WechatJSSignature> {
  return request({
    url: '/account/wechat/getSignature',
    method: 'get',
    params: {
      signUrl: url
    }
  })
}

export function getAccounts (areaId: number, params: AccountRequestParam): AxiosPromise<AccountResponse> {
  return request({
    url: `/areas/${areaId}/accounts`,
    method: 'get',
    params
  })
}

export function getDepartments (areaId: number): AxiosPromise<DepartmentItem[]> {
  return request({
    url: `/areas/${areaId}/departments`,
    method: 'get'
  })
}
